import React from 'react';
import { Target, Shield, Users, Crosshair, Award, Home } from 'lucide-react';

export default function Facilities() {
  const data = [
    { icon: <Target className="text-red-600" />, title: "Olympic Standard Range", desc: "Electronic target systems matching international standards." },
    { icon: <Crosshair className="text-gold" />, title: "Air Rifle Training", desc: "Premium air rifles and pistols for specialized sessions." },
    { icon: <Users className="text-red-600" />, title: "Professional Coaches", desc: "Learn from certified national level technical coaches." },
    { icon: <Shield className="text-gold" />, title: "Safe Environment", desc: "Strict safety protocols and clean environment for all members." },
    { icon: <Award className="text-red-600" />, title: "Progressive Training", desc: "Modules catering from beginners to advanced competitors." },
    { icon: <Home className="text-gold" />, title: "Spacious Infrastructure", desc: "Theory rooms and dedicated physical conditioning zones." },
  ];

  return (
    <section id="facilities" className="py-16 md:py-24 bg-zinc-950 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <p className="text-red-600 font-bold tracking-[0.3em] uppercase text-[10px] md:text-xs mb-3">Our Infrastructure</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white italic uppercase">
            WORLD-CLASS <span className="text-gold">FACILITIES</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {data.map((item, i) => (
            <div key={i} className="bg-white/5 border border-white/10 p-6 md:p-10 rounded-[2rem] hover:bg-white/10 transition-all group">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-zinc-900 rounded-2xl flex items-center justify-center mb-6 md:mb-8 group-hover:scale-110 transition-transform shadow-xl">
                {item.icon}
              </div>
              <h4 className="text-lg md:text-2xl font-bold text-white mb-3 md:mb-4 uppercase italic">{item.title}</h4>
              <p className="text-zinc-300 text-sm md:text-base leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}